<div class="ordering-context-body">
    <div class="ordering-context-body-summary">
        <div class="ordering-context-body-summary">
            @if (summaryOrderType() || showAsap() || summaryEarliestTime() || summaryExpectedTime() || summaryTable() || primaryStore() || primaryAddress()) {
                <div class="ordering-context-body-summary-primary">
                    @if (summaryOrderType()) {
                        <div class="ordering-context-body-summary-primary-order-type">{{ summaryOrderType() | translate }}</div>
                    }
                    @if (showAsap()) {
                        <div class="ordering-context-body-summary-primary-asap">
                            <div class="ordering-context-body-summary-primary-asap-label">{{ 'woa.heading.ordering-context.asap' | translate }}</div>
                            @if (orderingContextModel.canShowETA() && !orderingContextModel.evaluatingExpectedCompletionChange() && orderModel.orderEta()) {
                                <div class="ordering-context-body-summary-primary-asap-eta">{{ 'woa.heading.ordering-context.eta' | translate:{eta: orderModel.orderEta()} }}</div>
                            }
                        </div>
                    } @else if (summaryEarliestTime()) {
                        <div class="ordering-context-body-summary-primary-earliest-time">{{ 'woa.label.ordering-context.earliestTime' | translate:{earliestTime:summaryEarliestTime()} }}</div>
                    }
                    @if (summaryExpectedTime()) {
                        <div class="ordering-context-body-summary-primary-expected-time">{{ summaryExpectedTime() }}</div>
                    }
                    @if (summaryTable()) {
                        <div class="ordering-context-body-summary-primary-table">{{ summaryTable() }}</div>
                    }
                    @if (primaryStore()) {
                        <div class="ordering-context-body-summary-primary-from-store"
                             [innerHTML]="fromStore() | translate:{store: primaryStore()} | html"></div>
                    }
                    @if (primaryAddress()) {
                        <div class="ordering-context-body-summary-primary-to-address"
                             [innerHTML]="'woa.heading.ordering-context.toAddress' | translate:{address: primaryAddress()} | html"></div>
                    }
                </div>
            }
            @if (query()) {
                <div class="ordering-context-body-summary-query">{{ query() | translate }}</div>
            }
            @if (showWaiterName() || secondaryStore() || storeDetailsLink() || secondaryAddress()) {
                <div class="ordering-context-body-summary-secondary">
                    @if (showWaiterName()) {
                        <div class="ordering-context-body-summary-secondary-waiter">{{ identityModel.waiterName() }}</div>
                    }
                    @if (secondaryStore()) {
                        <div class="ordering-context-body-summary-secondary-store">{{ secondaryStore() }}</div>
                    }
                    @if (storeDetailsLink()) {
                        <woa-link class="ordering-context-body-summary-secondary-link"
                                  [link]="storeDetailsLink()"
                                  (onActivate)="orderingContextModel.viewCurrentStore()"></woa-link>
                    }
                    @if (secondaryAddress()) {
                        <div class="ordering-context-body-summary-secondary-address">{{ secondaryAddress() }}</div>
                    }
                </div>
            }
        </div>
    </div>
    @if (showRsaAction()) {
        <woa-button class="ordering-context-body-action rsa" [class.blocked]="menuModel.rsaBlocked()"
                    [tier]="ButtonTier.SECOND" [prominence]="ButtonProminence.HIGH" [icon]="'no-alcohol'"
                    (onActivate)="menuModel.setRsaBlock()"></woa-button>
    }
    @if (showContextAction()) {
        <woa-button class="ordering-context-body-action"
                    [tier]="ButtonTier.SECOND" [prominence]="ButtonProminence.HIGH" [label]="contextActionLabel()"
                    (onActivate)="orderingContextModel.changeOrderingContext(timeOnly())"></woa-button>
    }
</div>
@if (orderModel.showOrderTimeAllocationNotice()) {
    <woa-content-message [level]="MessageLevel.ERROR" [text]="orderModel.orderTimeAllocationNotice()">
        @if (showSelectTimeLink()) {
            <woa-link [link]="'woa.button.ordering-context.selectOrderTime'" [plain]="true"
                      (onActivate)="orderingContextModel.changeExpectedCompletion()"></woa-link>
        }
    </woa-content-message>
}
